import React from 'react'
import { DialogContent } from '@material-ui/core'
import { STEPS } from './constants'

const ModalLastStep = ({
  classes,
  currentStep,
  message,
  onClose,
  onRefetch,
}) => {
  return (
    <DialogContent>
      {currentStep === STEPS.SUCCESS ? (
        <div className={classes.container}>
          <div className={classes.result}>
            <div>{message}</div>
          </div>
          <div
            className={classes.modalButtonContainer}
            style={{ justifyContent: 'center' }}
          >
            <button
              className={classes.actionButton}
              onClick={() => {
                onClose()
                onRefetch()
              }}
            >
              CONTINUE
            </button>
          </div>
        </div>
      ) : null}
      {currentStep === STEPS.ERROR ? (
        <div className={classes.container}>
          <div className={classes.result}>
            <div>{message}</div>
          </div>
          <div
            className={classes.modalButtonContainer}
            style={{ justifyContent: 'center' }}
          >
            <button className={classes.cancelButton} onClick={onClose}>
              CLOSE
            </button>
          </div>
        </div>
      ) : null}
    </DialogContent>
  )
}

export default ModalLastStep
